import React, { createContext, useState } from "react";

import _ from "lodash";
import axios from "axios";

import Utils from "./Utils";

import md5 from "md5";

const UserContext = createContext();

/** Parse API body: axios may return object (application/json) or string (legacy / mixed output). */
function parseLoginBody(data) {
  if (typeof data !== "string") {
    return data;
  }
  let s = data.trim().replace(/^\uFEFF/, "");
  const i = s.indexOf("{");
  if (i > 0) {
    s = s.slice(i);
  }
  return JSON.parse(s);
}

/** Human-readable message when login request fails (404, 500, CORS, wrong URL). */
const axiosFailMessage = (err) => {
  if (err.response) {
    const s = err.response.status;
    const t = typeof err.response.data === "string" ? err.response.data.slice(0, 200) : JSON.stringify(err.response.data || {}).slice(0, 200);
    return `HTTP ${s} from API. ${t || ""}`.trim();
  }
  if (err.request) {
    return `${err.message || "Network error"} — check REACT_APP_API_URL, Apache/PHP, and CORS.`;
  }
  return err.message || "Request failed";
};

const UserProvider = (props) => {
  const [userData, setUserData] = useState(Utils.getUserData());
  const [showPlan, setShowPlan] = useState(false);
  const [showHowToModal, setShowHowToModal] = useState(false);

  const goLogin = ({ email, password }, callback) => {
    const body = `email=${encodeURIComponent(email)}&password=${encodeURIComponent(md5(password))}`;
    axios
      .post(Utils.apiUrl("auth/login"), body, Utils.apiHeaders())
      .then((res) => {
        let data = res.data;
        try {
          data = parseLoginBody(data);
        } catch (e) {
          callback(false, "Invalid response from server (not JSON).");
          return;
        }
        if (data.success) {
          setUserData(data);
          Utils.setUserData(data);
        }
        window.setTimeout(() => callback(data.success, data.message), 1000);
      })
      .catch((err) => {
        console.error("auth/login", err);
        callback(false, axiosFailMessage(err));
      });
  };
  const goImpersonate = ({ email }, callback) => {
    const body = `email=${encodeURIComponent(email)}`;
    axios
      .post(Utils.apiUrl("auth/impersonate"), body, Utils.apiHeaders())
      .then((res) => {
        let data = res.data;
        try {
          data = parseLoginBody(data);
        } catch (e) {
          callback(false, "Invalid response from server (not JSON).");
          return;
        }
        if (data.success) {
          setUserData(data);
          Utils.setUserData(data);
        }
        window.setTimeout(() => callback(data.success, data.message), 1000);
      })
      .catch((err) => {
        console.error("auth/impersonate", err);
        callback(false, axiosFailMessage(err));
      });
  };

  const goFrgpwd = (data, callback) => {
    var postdata = `email=${data.email}`;

    if (_.get(data, "otp", false)) {
      postdata += `&otp=${data.otp}`;
      postdata += `&new_password=${md5(data.new_password)}`;
    }

    axios
      .post(Utils.apiUrl("auth/frgpwd"), postdata, Utils.apiHeaders())
      .then((res) => {
        callback(res.data.success, res.data.message);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const changePassword = (data, callback) => {
    axios
      .post(Utils.apiUrl("auth/changepwd"), data, Utils.apiHeaders())
      .then((res) => {
        // if(res.data.success === false){
        //   Utils.removeSession();
        //   window.location.href = process.env.PUBLIC_URL + '/login';
        //   return;
        // }
        callback(res.data.success, res.data.message);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const saveProfile = (data, callback) => {
    axios
      .post(Utils.apiUrl("auth/saveprofile"), data, Utils.apiHeaders())
      .then((res) => {
        // if(res.data.success === false){
        //   Utils.removeSession();
        //   window.location.href = process.env.PUBLIC_URL + '/login';
        //   return;
        // }
        if (res.data.success) {
          setUserData(res.data.data);
          Utils.setUserData(res.data);
        }
        callback(res.data.success, res.data.message);
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const addToUserData = (data, callback = null) => {
    setUserData({ ...userData, ...data });
    Utils.addToUserData(data);
    if (callback) callback();
  };

  const goTraining = () => {
    return axios.get(Utils.apiUrl("auth/gotraining"), Utils.apiHeaders()).then((res) => {
      if (_.get(res, "data.learnerId", false)) {
        addToUserData({ learnerId: res.data.learnerId });
      }
      if (_.get(res, "data.redirecturl", false)) {
        window.open(res.data.redirecturl);
      }
      return res.data;
    });
  };

  const logoutTraining = () => {
    if (_.get(userData, "learnerId", false)) {
      return axios.get(Utils.apiUrl(`auth/logout/${userData.learnerId}`), Utils.apiHeaders());
    } else {
      return new Promise((resolve, reject) => {
        resolve({ data: { success: true } });
      });
    }
  };

  const logout = (callback) => {
    logoutTraining()
      .then((res) => {
        if (res.data.success) {
          setUserData(false);
          Utils.setUserData(false);
        }
        callback();
      })
      .catch((err) => {
        console.log(err);
        callback();
      });
  };

  const getHelpVideos = () => {
    return axios
      .get(Utils.apiUrl("resources/fetchhvs"), Utils.apiHeaders())
      .then((res) => (res.data && res.data.success ? res.data.mods : []))
      .catch(() => []);
  };

  return (
    <UserContext.Provider value={{ userData, addToUserData, saveProfile, goLogin, goImpersonate, goFrgpwd, goTraining, logout, changePassword, getHelpVideos, showPlan, setShowPlan, showHowToModal, setShowHowToModal }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;

export { UserProvider };
